import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetConfig = z.any()
export type TagsGetConfig = z.infer<typeof tagsGetConfig>

export const responseGetConfig = z.object({ "payload": z.object({ "subPeriodDays": z.object({ "TRIAL": z.number(), "STANDARD": z.number(), "VIP": z.null() }), "subPriceInfo": z.object({ "price": z.number(), "specialPriceByDate": z.array(z.object({ "from": z.string().datetime({ offset: true }), "to": z.string().datetime({ offset: true }), "price": z.number() })), "smsCrMemberSale": z.number(), "gdprClientSale": z.number() }) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetConfig = z.infer<typeof responseGetConfig>

interface IGetConfig extends BaseMethodType {
  tags: TagsGetConfig,
  response: ResponseGetConfig
}
export const URL = '/config'
export const validation = {
  get: {
    tags: tagsGetConfig,
    response: responseGetConfig
  }
}
export interface Config extends BaseRouteType {
  get: IGetConfig
}